/* Preserve the shopper's current search, filters, and on-page anchor when changing locale. */
(function () {
  'use strict';

  const current = window.location;
  if (!current.search && !current.hash) return;

  document.querySelectorAll('.yl-lang__btn, .yl-mmenu__language-link').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;
    const target = new URL(href, current.origin);
    if (target.origin !== current.origin) return;
    target.search = current.search;
    target.hash = current.hash;
    link.setAttribute('href', target.pathname + target.search + target.hash);
  });
})();
